export const useWaitingMessages = () => {
    const messages = [
        'Hang tight, we\'re getting your request ready...',
        'Lining everything up behind the scenes...',
        'Beep boop, the robots are chatting about the next step...',
        'Syncing with the cosmic processing grid...',
        'Negotiating with the seat selection squad...',
        'Passing your request through the fiber optic forest...',
        'Syncing our bytes with your vibes...',
        'Conversing with the cloud...',
        'Aligning your request\'s front end chakras...',
        'Making sure the details are just right...'
    ];

    const getRandomMessage = () => {
        const randomIndex = Math.floor(Math.random() * messages.length);
        return messages[randomIndex];
    };

    const getMessage = (index) => {
        return messages[index % messages.length];
    };

    return {
        messages,
        getRandomMessage,
        getMessage
    };
};